<template>
  <div class="ag-loading">
    <ag-icon
      icon="loading"
      :size="size"
      fill="currentColor"
      stroke="none"
      class="ag-loading__animate"
    />
    <p :style="{ fontSize: `${fontSize}px` }">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 50,
    },
    fontSize: {
      type: Number,
      default: 25,
    },
    text: {
      type: String,
      default: 'Loading',
    },
  },
}
</script>
